import { Billing } from 'ui/components/agent/patterns/Billing/Billing';

/**
 * 仲介業者請求情報
 */
export const AgentBilling: React.FC = () => {
    return <Billing />;
};
